<template>
  <div
    ref="sideModal"
    :class="[
      feature === 'address' ? 'address-custom-modal' : 'custom-modal',
      show ? 'show-modal' : '',
      $_fsaHsaPromo_isActiveFsaHsaPromo && isOnboardingRedesign ? 'tw-h-[calc(100vh-60px)] md:tw-h-[calc(100vh-60px)] lg:tw-h-[calc(100vh-80px)] tw-top-[60px] md:tw-top-[60px] lg:tw-top-[80px]' : '',
      $_fsaHsaPromo_isActiveFsaHsaPromo && !isOnboardingRedesign ? 'tw-h-[calc(100vh-60px)] md:tw-h-[calc(100vh-86px)] tw-top-[60px] md:tw-top-[86px]' : '',
      fullWidth ? '!tw-w-full' : '',
    ]"
  >
    <div
      ref="modalHeader"
      :style="{
        paddingTop: feature === 'address' && $_fsaHsaPromo_isActiveFsaHsaPromo && isOnboardingRedesign ? '80px' : paddingTop,
      }"
      :class="['custom-header', headerClass, {'!tw-flex !tw-justify-between tw-flex-col-reverse tw-py-6 tw-px-4': isOnboardingRedesign}]"
    >
      <template v-if="!isOnboardingRedesign">
        <b-icon
          v-if="showClose"
          class="close-icon"
          icon="x-circle-fill"
          variant="info"
          scale="1.3"
          @click="close"
        />
      </template>
      <slot name="header"></slot>

      <div
        v-if="isOnboardingRedesign"
        class="tw-cursor-pointer tw-flex tw-justify-end tw-self-end"
      >
        <svg
          v-if="showClose"
          width="33"
          height="33"
          viewBox="0 0 33 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="close"
        >
          <path
            d="M21.1734 10.3143L22.5763 11.7172L18.3224 15.9712L22.6895 20.3383L21.1282 21.8996L16.7611 17.5325L12.5071 21.7864L11.1042 20.3835L15.3582 16.1296L11.0137 11.7851L12.575 10.2238L16.9195 14.5683L21.1734 10.3143Z"
            fill="#1A1A1A"
          />
        </svg>
      </div>
    </div>
    <div
      v-height="setDimensions"
      class="custom-body tw-overflow-y-auto"
      :class="[bodyClass]"
      :style="{ height: $_fsaHsaPromo_isActiveFsaHsaPromo ? `calc(100vh - 86px - ${headerHeight}px)` : feature === 'address' ? 'calc(100vh-250px)' : `calc(100vh - ${headerHeight}px)` }"
    >
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { fsaHsaPromoMixin } from '@/mixins/fsaHsaPromo';
import calculateBottom from '@/mixins/calculateBottom';
import resizeObserverMixin from '@/mixins/resizeObserverMixin';

export default {
  mixins: [fsaHsaPromoMixin, calculateBottom, resizeObserverMixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    headerClass: {
      type: String,
      default: '',
    },
    bodyClass: {
      type: String,
      default: '',
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    feature: {
      type: String,
      default: '',
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    elementId: {
      type: String,
      default: 'fixed-header',
    },
    targetRefName: {
      type: String,
      default: 'onboarding-progress-id',
    },
  },
  data() {
    return {
      height: document.documentElement.clientHeight,
      headerHeight: 0,
    };
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    paddingTop() {
      return this.elementBottom + 'px !important';
    }
  },
  watch: {
    show(val) {
      this.$store.commit('global/SET_MODAL_STATE', val);
    },
  },
  created() {
    addEventListener('popstate', this.popStateHandler);
  },
  mounted() {
    this.headerHeight = this.$refs.modalHeader.clientHeight;
  },
  destroyed() {
    removeEventListener('popstate', this.popStateHandler);
  },
  methods: {
    close(event) {
      this.$store.commit('global/SET_MODAL_STATE', false);
      this.$emit('exit', event);
    },
    setDimensions({ height }) {
      this.height = height;
    },
    popStateHandler(event) {
      if (this.$store.state.global.isModalOpen) {
        this.close(event);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$width: 50%;

.custom-modal {
  position: fixed;
  width: $width;
  height: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  transform: translateX(100%);
  z-index: 600;
  background-color: $white;
  transition: transform 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955);
  transition-delay: 0.15s;

  &.show-modal {
    transform: translateX(0);
  }

  @include media-breakpoint-down(md) {
    width: 100%;
  }

  .custom-header {
    position: relative;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    flex-wrap: wrap;
    // flex-flow: column;

    &.terms-title {
      justify-content: flex-start;
      padding: 15px 2rem;
    }

    .close-icon {
      position: absolute;
      top: 1rem;
      right: 1.6rem;
      cursor: pointer;
      z-index: 99;

      @include media-breakpoint-down(sm) {
        font-size: 1.5rem;
      }

      @include media-breakpoint-up(xxl) {
        font-size: 1.5rem;
      }
    }
  }

  .custom-body {
    padding: 0 2rem;

    &.terms-body {
      overflow: auto;
    }

    &.why-body {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
}

// Similar to custom-modal class above
.address-custom-modal {
  position: fixed;
  width: 40%;
  height: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  transform: translateX(100%);
  z-index: 601;
  background-color: $white;
  transition: transform 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955);
  transition-delay: 0.15s;

  &.show-modal {
    transform: translateX(0);
  }

  @include media-breakpoint-down(md) {
    width: 100%;
  }

  .custom-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    flex-flow: column;

    &.terms-title {
      justify-content: flex-start;
      padding: 15px 2rem;
    }

    .close-icon {
      position: absolute;
      top: 1rem;
      right: 1.6rem;
      cursor: pointer;
      z-index: 99;

      @include media-breakpoint-down(sm) {
        font-size: 1.5rem;
      }

      @include media-breakpoint-up(xxl) {
        font-size: 1.5rem;
      }
    }
  }

  .custom-body {
    padding: 2rem;

    &.terms-body {
      overflow: auto;
    }

    &.why-body {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
}
</style>
